import axios from 'axios';
import { baseURL } from '@/config/index';
import { Toast } from 'vant';

interface Confg {
  method: string,
  url: string,
  data?: any,
  params?: any,
}
// 请求拦截
axios.interceptors.request.use((config: any) => {
  const { userId } = sessionStorage;
  const data = config;
  data.params = { userId, ...config.params };
  Toast.loading({
    message: '加载中...',
    forbidClick: true,
    loadingType: 'spinner',
    duration: 0,
  });
  return data;
}, (error) => {
  console.log(error);
  Promise.reject(error);
});
axios.interceptors.response.use((response) => {
  Toast.clear();
  return response;
}, (error) => (
  Promise.reject(error)
));
/* eslint lines-between-class-members: ["error", "always"] */
class Http {
  config: any;

  constructor() {
    this.config = {
      baseURL,
      timeout: 9000,
    };
  }

  request(obj: Confg) {
    return new Promise((resolve, reject) => {
      axios.request({ ...this.config, ...obj }).then((res: any) => {
        resolve(res.data);
      }).catch((err) => {
        reject(err);
      });
    });
  }
}
export default new Http();
